import { useCurrentCandidate } from '@innowise-group/core';
import { Icon } from '@innowise-group/mui-kit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './hrm-profile.styles';

const HRMProfile: React.FC = () => {
  const { t } = useTranslation();
  const currentCandidate = useCurrentCandidate();

  const isCandidateAlreadyLinked = !!currentCandidate?.hrmId;

  return (
    <div>
      {isCandidateAlreadyLinked && (
        <Styled.EmailTooltip>
          <Icon type="u_binary_tree" className="icon" viewBox="0 0 20 20" />
          {t('pages.candidates.statuses.hrmLinkTooltip')}
        </Styled.EmailTooltip>
      )}
    </div>
  );
};

export default HRMProfile;
